module.exports = __webpack_public_path__ + "static/media/BreathAwareness10.19f11521.mp3";